import React, { FC, Fragment, useState } from 'react';
import { Box, Button, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

type ChildClinicTypeSelectProps = {
    onClose: () => void;
    onTypeSelected: (type: ChildClinicType) => void;
    parentOrganizationNumber: string;
};
const ChildClinicTypeSelect: FC<ChildClinicTypeSelectProps> = ({
    onClose,
    onTypeSelected,
    parentOrganizationNumber,
}: ChildClinicTypeSelectProps) => {
    const { t: translate } = useTranslation(['organization']);
    const [selectedType, setSelectedType] = useState(ChildClinicType.SAME_ORGANIZATION);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedType(
            event.target.value === 'SAME_ORGANIZATION'
                ? ChildClinicType.SAME_ORGANIZATION
                : ChildClinicType.STANDALONE_ORGANIZATION,
        );
    };

    const handleNextButtonClicked = () => {
        onTypeSelected(selectedType);
    };

    return (
        <Fragment>
            <Box>
                <Box mb={2}>{translate('organization:CHILD_CLINIC_TYPE_INFORMATION')}</Box>
                <Box mb={3}>
                    <FormControl>
                        <RadioGroup value={selectedType} onChange={handleChange}>
                            <FormControlLabel
                                value={ChildClinicType.SAME_ORGANIZATION}
                                control={<Radio />}
                                label={translate('organization:SAME_ORGANIZATION', {
                                    orgNumber: parentOrganizationNumber,
                                })}
                            />
                            <FormControlLabel
                                value={ChildClinicType.STANDALONE_ORGANIZATION}
                                control={<Radio />}
                                label={translate('organization:STANDALONE_ORGANIZATION')}
                            />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>
            <Box mt={1} display="flex">
                <Box flexGrow={1}>
                    <Button onClick={() => onClose()}>{translate('common:CANCEL')}</Button>
                </Box>

                <Button variant="contained" onClick={handleNextButtonClicked}>
                    {translate('common:NEXT_STEP')}
                </Button>
            </Box>
        </Fragment>
    );
};

export enum ChildClinicType {
    STANDALONE_ORGANIZATION = 'STANDALONE_ORGANIZATION',
    SAME_ORGANIZATION = 'SAME_ORGANIZATION',
}

export default ChildClinicTypeSelect;
